// Named exports for hooks, helpers, types, and UI components
export * from './core/components/hooks';
export * from './core/helper/lazyLoad';
export * from './core/types';
export * from './ui';
export type { EditorProps };

// Explicit import and export for Editor
import Editor, { EditorProps } from './editor/Editor';
export default Editor;

// Export VERSION constant
export const VERSION = '###VERSION###';

// Ensure proper internal naming for all imported utility functions
import { migrateValue } from './core/migrations/migrate';
import { createValue } from './core/utils/createValue';
import deepEquals from './core/utils/deepEquals';
import { getTextContents } from './core/utils/getTextContents';
import { objIsNode } from './core/utils/objIsNode';
import makeUniformsSchema from './ui/AutoformControls/makeUniformsSchema';

// Re-export all utility functions explicitly to ensure internal names are handled correctly
export {
  createValue,
  deepEquals,
  getTextContents,
  makeUniformsSchema,
  migrateValue,
  objIsNode,
};
